import { Component, computed, input, output } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

import { FlxButtonModule, FlxIconModule } from '@flowx/angular-ui-toolkit'
import {
  TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX,
  TOOLTIP_DEFAULT_DELAY,
} from '@flowx/designer/modules/core/dictionary/constants'
import { FlxClickStopPropagationDirective } from '@flowx/designer/modules/core/directives/stop-propagation.directive'

import { FlxNotificationContentComponent } from '../../notification-content/notification-content.component'
import { ExtendedNotification } from '../../notifications.model'
import { relativeAgeLabel } from '../notifications-center.model'

@Component({
  selector: 'flx-notification-center-item',
  imports: [
    TooltipModule,
    FlxButtonModule,
    FlxIconModule,
    FlxClickStopPropagationDirective,
    FlxNotificationContentComponent,
  ],
  templateUrl: './notification-center-item.component.html',
  host: {
    // `group` so the read toggle can reveal itself on hover of the whole row.
    'class': 'group block px-5 py-3 hover:bg-neutral-50',
    '[class.bg-blue-50]': '!notification().markedRead',
    '[class.cursor-pointer]': '!notification().markedRead',
    'data-testid': 'notification-center-item',
    '[attr.data-status]': 'notification().status',
    '[attr.data-read]': 'notification().markedRead',
    '(click)': 'onRowClick()',
  },
})
export class FlxNotificationCenterItemComponent {
  TOOLTIP_DEFAULT_DELAY = TOOLTIP_DEFAULT_DELAY
  TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX = TOOLTIP_ABOVE_NOTIFICATIONS_Z_INDEX

  notification = input.required<ExtendedNotification>()
  currentTime = input.required<number>()

  markedReadChange = output<boolean>()
  actionClicked = output<void>()

  age = computed(() => relativeAgeLabel(this.notification().createdTimestamp, this.currentTime()))

  readToggleLabel = computed(() =>
    this.notification().markedRead ? 'Mark as unread' : 'Mark as read'
  )

  /** Clicking an unread row reads it; a click on one of its buttons stops at the button. */
  onRowClick(): void {
    if (!this.notification().markedRead) {
      this.markedReadChange.emit(true)
    }
  }

  toggleRead(): void {
    this.markedReadChange.emit(!this.notification().markedRead)
  }
}
